module.exports = __webpack_public_path__ + "static/media/me_wedding_super_compressed.1e0868ce.jpg";